// Nuxt 3의 Composition API에서 전역 상태를 관리하기 위한 useState 함수 import
import { useState } from '#app';

/**
 * 전역 로딩 상태를 관리하는 커스텀 훅
 * - 'isLoading'이라는 고유 키를 사용하여 상태를 생성하거나 가져온다.
 * - Nuxt의 useState는 이 키를 기준으로 전역에서 같은 상태를 공유하게 해줌.
 * - 최초 실행 시 false로 초기화되며, 이후에는 동일한 ref가 반환됨.
 */
export const useLoadingStore = () => {
  return useState<boolean>('isLoading', () => false);
};
